import type {
  RegionalHighlightListingStatus,
  RegionalHighlightListingStatusesByListingId,
} from '@/types/regionalHighlight';

/**
 * Looks up a Regional Highlight listing status by the exact listing id the FE
 * requested from the API. The backend keys the response map by those same ids.
 */
export const getRegionalHighlightStatusForListing = (
  statuses: RegionalHighlightListingStatusesByListingId | undefined,
  listingId: string | null | undefined,
): RegionalHighlightListingStatus | undefined => {
  if (!statuses || !listingId) {
    return undefined;
  }

  return statuses[listingId];
};
